module.exports = __webpack_public_path__ + "img/logo_espas.a9af6dbc.svg";